import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-search-icon',
  template: `
    <svg
      width="24"
      height="25"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.502 14.5H14.712L14.432 14.23C15.412 13.09 16.002 11.61 16.002 10C16.002 6.41 13.092 3.5 9.50195 3.5C5.91195 3.5 3.00195 6.41 3.00195 10C3.00195 13.59 5.91195 16.5 9.50195 16.5C11.112 16.5 12.592 15.91 13.732 14.93L14.002 15.21V16L19.002 20.99L20.492 19.5L15.502 14.5ZM9.50195 14.5C7.01195 14.5 5.00195 12.49 5.00195 10C5.00195 7.51 7.01195 5.5 9.50195 5.5C11.992 5.5 14.002 7.51 14.002 10C14.002 12.49 11.992 14.5 9.50195 14.5Z"
        fill="currentColor"
      />
    </svg>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchIconComponent {}
